<template>
    <div>
        <div
            class="file-drop-area border rounded p-4 text-center mb-3"
            @dragenter="dragEnter" 
            @dragleave="dragLeave"
            @dragover.prevent
            @drop.prevent="dropFile"
            :class="{ 'file-drop-enter': isEnter }"
            @click="$refs.file.click()"
            role="button"
            >
            <div class="">
                ドラッグアンドドロップ<br>
                or<br>
                カメラ/選択
            </div>
            <input ref="file" type="file" multiple accept="image/*" class="d-none" @change="capture" />
        </div>
    
        <b-row>
            <b-col
                v-for="(base64, index) in base64s"
                cols="2"
                :key="index"
                >
                <div class="text-right">
                    <a href="#" class="text-danger" @click="base64s.splice(index, 1)">削除</a>
                </div>
                <div class="square">
                    <img :src="base64" />
                </div>
                <div class="text-center">
                    <a href="#" class="text-dark" @click="(index > 0) ? ($utils.swap(base64s, index - 1, index)) : null">◀前へ</a>
                    &emsp;
                    <a href="#" class="text-dark" @click="(index < base64s.length - 1) ? ($utils.swap(base64s, index + 1, index)) : null">後へ▶</a>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<style>
.square {
    aspect-ratio: 1 / 1; /* 正方形 */
    width: 100%;
    overflow: hidden; /* 画像がはみ出さないように */
    position: relative;
}
.square img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* トリミングして枠いっぱいに表示 */
}
</style>
<script>
export default {
    props: [
        'value'
    ],
    data() {
        return {
            isEnter: false,
            base64s: [],
        }
    },
    watch: {
        base64s: {
            handler() {
                this.$emit('input', this.base64s)
            },
            deep: true
        }
    },
    methods: {
        dragEnter() {
            this.isEnter = true
        },
        dragLeave() {
            this.isEnter = false
        },
        dropFile() {
            this.processFileList(event.dataTransfer.files)
            this.isEnter = false
        },
        capture() {
console.log(event)
            this.processFileList(event.target.files)
            this.$refs.file.value = ''
        },
        async processFileList(fileList) {
            const files = [ ...fileList ]
            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                const reader = new FileReader()
                if (file) {
                    reader.readAsDataURL(file)
                    await new Promise(resolve => reader.onload = () => resolve())
                    this.base64s.push(reader.result)
                }
            }
        },
    },
}
</script>
<style>
.file-drop-area {
    border-style: dotted !important;
    border-width: 5px !important;
}
.file-drop-enter {
    border-color: powderblue !important;
}
</style>
